import { useCalculoOutletContext } from '@/pages/CalculoPonto.context'
import { AxiosError } from 'axios'
import DialogGuide from 'global/guides/Dialog'
import React from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { calculo as calculo_api, espelhoPonto } from 'service/api'
import { toast } from 'sonner'

const ExcluirCalculo: React.FC = () => {
    const navigate = useNavigate()
    const [isLoading, setIsLoading] = React.useState(false)
    const { id } = useParams()
    const { data } = useCalculoOutletContext()

    const calculo = data.find((item: any) => item.id === Number(id))

    if (!calculo) return null

    const handleSubmit = async () => {
        setIsLoading(true)

        try {
            await calculo_api.historico.delete(calculo.id)

            toast.success('Cálculo excluído com sucesso')

            await espelhoPonto.invalidateQueries()
            navigate(-1)
        } catch (err) {
            const error = err as AxiosError

            if (error.message) {
                toast.error(error.message)
            } else {
                toast.error('Ocorreu um erro ao excluir o cálculo')
            }
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <DialogGuide.Root
            width="fit"
            loading={isLoading}
            onSubmit={handleSubmit}
        >
            <DialogGuide.Title wrap>
                Deseja excluir o cálculo do ponto do funcionário{' '}
                {calculo?.Funcionario?.nome}?
            </DialogGuide.Title>
            <DialogGuide.Actions>
                <DialogGuide.Actions.SecondaryButton>
                    Cancelar
                </DialogGuide.Actions.SecondaryButton>
                <DialogGuide.Actions.PrimaryButton color="error">
                    Excluir
                </DialogGuide.Actions.PrimaryButton>
            </DialogGuide.Actions>
        </DialogGuide.Root>
    )
}

export default ExcluirCalculo
